import {
  SET_PHOTOSWIPE_OPEN,
  SET_PHOTOSWIPE_INDEX,
  SET_PHOTOSWIPE_MOMENT,
  SET_PHOTOSWIPE_ITEMS,
  SHOW_AUTHORIZE_KNOCKOUT,
  SHOW_CROP_MOMENT,
  SET_DRAGGABLE_IMAGE,
  SET_PHOTOSWIPE_HIDDEN
} from 'shared/actions/types';

import {
  SHOW_PRINT_SIZE_EDITS
} from 'app/actions/types';

export const setPhotoSwipeOpen = isOpen => dispatch => {
  dispatch({
    type: SET_PHOTOSWIPE_OPEN,
    payload: isOpen
  });

  return Promise.resolve();
}

export const setPhotoSwipeHidden = isHidden => dispatch => {
  dispatch({
    type: SET_PHOTOSWIPE_HIDDEN,
    payload: isHidden
  });

  return Promise.resolve();
}

export const setPhotoSwipeIndex = index => dispatch => {
  dispatch({
    type: SET_PHOTOSWIPE_INDEX,
    payload: index
  });

  return Promise.resolve();
}

export const setPhotoSwipeMoment = moment => dispatch => {
  dispatch({
    type: SET_PHOTOSWIPE_MOMENT,
    payload: moment
  });

  return Promise.resolve();
}

export const setPhotoSwipeItems = items => dispatch => {
  dispatch({
    type: SET_PHOTOSWIPE_ITEMS,
    payload: items
  });

  return Promise.resolve();
}

export const showAuthorizeKnockout = (isShow, momentId) => dispatch => {
  dispatch({
    type: SHOW_AUTHORIZE_KNOCKOUT,
    payload: { visible: isShow, reknockout_moment_id: momentId }
  })
  return Promise.resolve();
}

export const showCropMoment = (isShow, moment) => dispatch => {
  dispatch({
    type: SHOW_CROP_MOMENT,
    payload: { visible: isShow, crop_moment_src: moment.src, crop_moment_id: moment.id, crop_moment: moment }
  })
  return Promise.resolve();
}

export const showPrintSizeEdits = (isVisible, moment) => dispatch => {
  dispatch({
    type: SHOW_PRINT_SIZE_EDITS,
    payload: { visible: isVisible, crop_moment_src: moment?.src, crop_moment_id: moment?.id, crop_moment: moment }
  })
  return Promise.resolve();
}

export const setDraggableImage = isDrag => dispatch => {
  dispatch({
    type: SET_DRAGGABLE_IMAGE,
    payload: isDrag
  });
  return Promise.resolve();
}


